module.exports = __webpack_public_path__ + "static/media/image-992.d3f3e24c.webp";